// src/pages/xray/XrayLobby/TabErrors
// .js
import React from 'react';

const TabErrors = ({
  selectedTabsErrors,
  setSelectedTabsErrors,
  loggedErrorsLimits,
  conntrackTableLimits,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {['LOGGED Errors', 'CONNTRACK TABLE SIZE'].map((label, index) => (
          <label
            key={index}
            className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
              selectedTabsErrors === `tabsErrors${index + 1}`
                ? 'border-b-0 font-bold'
                : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
            }`}
          >
            <input
              type="radio"
              className="hidden"
              name="tabs-group"
              checked={selectedTabsErrors === `tabsErrors${index + 1}`}
              onChange={() => setSelectedTabsErrors(`tabsErrors${index + 1}`)}
            />
            {label}
          </label>
        ))}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedTabsErrors === 'tabsErrors1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">ERRORS found in SYSLOG</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {loggedErrorsLimits || 'No Errors status available'}
            </pre>
          </div>
        )}

        {selectedTabsErrors === 'tabsErrors2' && (
          <div>
            <h1 className="font-bold text-2xl p-2">
              Size of the ConnTrack table
            </h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {conntrackTableLimits || 'No ConnTrack table size available'}
            </pre>
            <div className="text-lg p-2">
              <p className="py-2 bg-blue-100 p-4 rounded-md border border-blue-300 mt-2 text-sm">
                VOS tracks incoming and outgoing IP data connections via a
                Connection Tracking table. Each entry in this table is called a
                ConnTrack entry. The size of this table is not infinite...
                {/* Shortened for brevity */}
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TabErrors;
